import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { maxWidth } from 'config/constants';

export const StyledSitePerformanceChartJsWrapper = styled.div`
  ${(): FlattenSimpleInterpolation => css`
    position: relative;
    width: 100%;
    height: auto;
  `}
`;

export const StyledSitePerformanceChartJs = styled.div<{ chartPlotHeight: number }>`
  ${({ theme: { kcc }, chartPlotHeight }): FlattenSimpleInterpolation => {
    const plotHeight = chartPlotHeight;

    return css`
      position: relative;
      height: auto;
      background-color: ${kcc.colors.WHITE};
      font-family: ${kcc.typography.FONT_FAMILY};
      color: ${kcc.colors.TEXT};
      border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.GRAY_100};
      padding: ${kcc.spacing.LG};

      .ant-skeleton {
        margin-top: ${kcc.spacing.SM};
        width: 100%;
        height: 100%;

        .ant-skeleton-paragraph {
          li {
            width: 100% !important;
          }
        }
      }

      .site-performance-chart__title-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: ${kcc.spacing.XS};
        margin-bottom: ${kcc.spacing.XXS};
        min-height: 24px;
      }

      .site-performance-chart__sort-bar {
        margin-top: ${kcc.spacing.XXS};

        ${maxWidth.s} {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .site-performance-chart__sort-label {
        padding-top: 2px;
        color: ${kcc.colors.TEXT};
        white-space: nowrap;
      }

      .site-performance-chart__title {
        font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
        font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
        line-height: 24px;
        text-transform: capitalize;
        margin: 0;
      }

      .site-performance-chart__legend {
        margin-top: ${kcc.spacing.BASE};
      }

      .site-performance-chart__chart-note-text {
        font-size: ${kcc.typography.FONT_SIZE.SM}px;
        font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
        line-height: ${kcc.typography.LINE_HEIGHT.SM};
        color: ${kcc.colors.TEXT_SECONDARY};
        text-transform: capitalize;
        margin: 0;
      }

      .site-performance-chart__chart-note-square-left,
      .site-performance-chart__chart-note-square-right {
        height: ${kcc.spacing.XS};
        width: ${kcc.spacing.XS};
        flex-shrink: 0;
      }

      .site-performance-chart__chart-note-square-left {
        background-color: ${kcc.colors.PETROL[500]};
      }

      .site-performance-chart__chart-note-square-right {
        background-color: ${kcc.colors.GRAY_250};
      }

      .site-performance-chart__chart-container {
        // extend for last item in the chart
        height: ${plotHeight + 30}px;
        width: 100%;
        overflow: visible;

        .site-performance-chart__chart {
          height: 100%;
          overflow: visible;
        }
      }
    `;
  }}
`;

export const StyledSitePerformanceChartJsCanvasWrapper = styled.div`
  ${(): FlattenSimpleInterpolation => css`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: visible;

    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  `}
`;
